import React from 'react';
import { Box, Typography, Grid, CircularProgress } from '@mui/material';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import { container, descContainer, rankingContainer } from './styles';
import { useAnalysisData } from 'src/api/hooks/use-analysis-data';
import { brand } from 'src/themes/palette';
import { ProfileStrengthCard, StatCard } from './card-view';
import { RatingComparison } from './rating';
import { useSearchParams } from 'react-router-dom';

const AnalysisScreen: React.FC = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token') ?? '';

  const { loading, data } = useAnalysisData({ token });

  if (loading) {
    return (
      <Box
        sx={container}
        alignContent="center"
        alignItems="center"
        bgcolor={brand.background}
        justifyContent="center">
        <CircularProgress color="secondary" />
      </Box>
    );
  }

  return (
    <Box sx={container}>
      <Box mt={4} sx={descContainer}>
        <Typography variant="h4" gutterBottom>
          Google Maps Profile Audit
        </Typography>
        <Typography variant="subtitle1" color="textSecondary">
          Comprehensive analysis of your business presence
        </Typography>
      </Box>

      <Box mt={6} display="flex" justifyContent="center">
        <ProfileStrengthCard
          name={data?.name}
          date={data?.date}
          radius={(data?.radius ?? 0) / 1000}
          strength={data?.strength ?? 0}
        />
      </Box>

      <Box sx={rankingContainer}>
        <Grid
          sx={{ width: '70%' }}
          container
          spacing={4}
          mt={4}
          direction="column">
          {data?.keywordsRankings?.map((ranking, index) => (
            <Grid
              container
              mt={2}
              spacing={2}
              key={index}
              justifyContent="center">
              <Grid item xs={12} md={6}>
                <StatCard
                  title={ranking.keyword}
                  icon={
                    <EmojiEventsIcon
                      color={ranking.strength >= 20 ? 'error' : 'secondary'}
                    />
                  }
                  value={ranking.strength ?? 0}
                  progress={
                    ranking.strength ? ((20 - ranking.strength) / 19) * 100 : 0
                  }
                  label={
                    ranking.strength >= 20
                      ? 'Ranked lower than #20'
                      : 'Local Pack Position'
                  }
                />
              </Grid>

              <Grid item xs={12} md={6}>
                <RatingComparison
                  userRating={data.rating ?? 0}
                  competitorRating={ranking.rating ?? 0}
                />
              </Grid>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Box>
  );
};

export { AnalysisScreen };
